import { Typography, makeStyles } from '@gogame/components';

const useStyles = makeStyles(() => ({
  text: {
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    'word-break': 'break-all',
  },
}));

const CustomBodyText = ({ name }) => {
  const classes = useStyles();

  return <Typography className={classes.text}>«{name}»</Typography>;
};

export default CustomBodyText;
